import { rolesMap } from "./roles-constants";
const baseButtons = ['generalInfo', 'additionalDetails', 'currencies', 'proofOfPurchase', 'referralRewards']
const peButtons = ['limits', 'participationExport'];
const luckyNumbersButtons = ['generalInfo', 'limits', 'proofOfPurchase', 'additionalDetails', 'luckyNumbersExport'];
const iwButtons = ['limits', 'prizes','participationExport', 'winningMoments', 'vouchers',  'notification']
const cngButtons = ['limits', 'prizes', 'allocationRules', 'vouchers',  'notification']
const cngPrizeManagerButtons = ['prizes', 'vouchers']
const adminPanelButtons = ['permissions', 'emailTemplates', 'emailNotifications', 'replicationManagement']

export const getFlowTabButtons = (promotionMechanic: string, userMaxRole: number) => {
    if (userMaxRole === rolesMap.ExportManager) {
        switch (promotionMechanic) {
            case 'Instant Win':
            case 'Prize Draw (Lottery)':
                return ['participationExport'];
            case 'Lucky Numbers':
                return ['luckyNumbersExport'];
            default:
                return [];
        }
    }

    let flowButtons = [];

    switch (promotionMechanic) {
        case 'Instant Win':
            flowButtons = iwButtons;
            break;
        case 'Prize Draw (Lottery)':
            flowButtons = peButtons;
            break;
        case 'Collect & Get':
            flowButtons = userMaxRole === rolesMap.PrizeManager ? cngPrizeManagerButtons : cngButtons;
            break;
        case 'Admin Panel':
            flowButtons = adminPanelButtons
            break;
        case 'Lucky Numbers':
            flowButtons = luckyNumbersButtons;
            break;
        case 'Auto Collect & Get':
            flowButtons = userMaxRole === rolesMap.PrizeManager ? cngPrizeManagerButtons : cngButtons;
            break;
        default:
            flowButtons = [];
    }

    return promotionMechanic === 'Admin Panel' || userMaxRole === rolesMap.PrizeManager || promotionMechanic === 'Lucky Numbers'
        ? [...flowButtons]
        : [...baseButtons, ...flowButtons];
}

export const flowTabButtonsMap = {
    generalInfo: {
        label: "General Info"
    },
    prizes: {
        label: "Prizes"
    },
    vouchers: {
        label: "Vouchers"
    },
    winningMoments: {
        label: "Winning Moments"
    },
    limits: {
        label: "Limits"
    },
    proofOfPurchase: {
        label: "Proof of Purchase"
    },
    allocationRules: {
        label: "Allocation Rules"
    },
    currencies: {
        label: "Currencies"
    },
    luckyNumbersExport: {
        label: "Lucky Numbers Export"
    },
    referralRewards: {
        label: "Referral Rewards"
    },
    participationExport: {
        label: "Participation Export"
    },
    additionalDetails: {
        label: "Additional Details"
    },
    permissions: {
        label: "Permissions"
    },
    emailTemplates: {
        label: "Email Templates"
    },
    emailNotifications: {
        label: "Email Notifications"
    },
    replicationManagement: {
        label: "Replication Management"
    },
    notification: {
        label: "Notifications"
    }
}
